var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.4905L4.78327 16.7072C4.58809 16.9024 4.33967 17 4.03802 17C3.73638 17 3.48796 16.9024 3.29278 16.7072C3.09759 16.512 3 16.2636 3 15.962C3 15.6603 3.09759 15.4119 3.29278 15.2167L8.50951 10L3.29278 4.78327C3.09759 4.58809 3 4.33967 3 4.03802C3 3.73638 3.09759 3.48796 3.29278 3.29278C3.48796 3.09759 3.73638 3 4.03802 3C4.33967 3 4.58809 3.09759 4.78327 3.29278L10 8.50951L15.2167 3.29278C15.4119 3.09759 15.6603 3 15.962 3C16.2636 3 16.512 3.09759 16.7072 3.29278C16.9024 3.48796 17 3.73638 17 4.03802C17 4.33967 16.9024 4.58809 16.7072 4.78327L11.4905 10L16.7072 15.2167C16.9024 15.4119 17 15.6603 17 15.962C17 16.2636 16.9024 16.512 16.7072 16.7072C16.512 16.9024 16.2636 17 15.962 17C15.6603 17 15.4119 16.9024 15.2167 16.7072L10 11.4905Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.89ecf69526ec4cc158b83ebc79630b42.svg";
export { ForwardRef as ReactComponent };